import * as React from "react";
import {  FileUploader,  TagBox,  Validator } from "devextreme-react";
import { Button as TagBoxButton } from 'devextreme-react/tag-box';
import { UploadedEvent, UploadErrorEvent } from "devextreme/ui/file_uploader";
import { useCallback, useMemo, useRef, useState } from "react";
import { dxButtonOptions } from "devextreme/ui/button";
import FileSelection from "./FileSelection";
import { CustomRule } from "devextreme-react/validator";
import { useListSource } from "./hooks/DataSource";

interface IProps<TModel> {
    apiUrl: string
    token?: string
    allowedExtensions: string[];
    value?: TModel[] | TModel;
    valueChange?: (e?: TModel[]) => void;
    /**Textbox attributes */
    inputAttr?: any;
    /** default fieldname = fileName */
    textFieldName?: string;
    placeholder?: string;
    required?: boolean;
    requiredMessage?: string
    /** inputFormName must have the same name as the input argument name on server! default is 'file'. 
     * public Post(IFormFile file, [FromForm] string chunkMetadata) */
    inputFormName?: string
    multiple?: boolean;
    label?: string
}

const FileBox = <TModel extends { id?: number, [x: string]: any }>({
    apiUrl, token, allowedExtensions, valueChange, value, inputAttr, textFieldName,
    placeholder, required, requiredMessage, inputFormName, multiple, label

}: IProps<TModel>) => {

    const refFileUpload = useRef<FileUploader>(null);
    const [showFileManager, setShowFileManager] = useState(false);

    //const beforeUploadDocHandler = useCallback(async (e: BeforeSendEvent) => {
    //    e.request.setRequestHeader("Authorization", "Bearer " + token)
    //    setIsInDropZone(false)
    //}, [token])

    //converteer value altijd naar een array met docs.
    const docs = useMemo(() => (Array.isArray(value) && value) || (value && [value]) || [], [value])
    const dsDocs = useListSource(docs); //deze DS is nodig om tagbox items te kunnen verwijderen.

    //const updateState = useCallback(() => (isArray(value) && value) || (value && [value]) || [], [value])

    /*const [docs, setDocs] = useState<TModel[]>([])*/

    //useEffect(() => {
    //    setDocs((isArray(value) && value) || (value && [value]) || []);
    //}, [value])

    const headers = useMemo(() => ({
        Authorization: "Bearer " + token
    }), [token])

    const saveSelectionHandler = useCallback((docs: TModel[]) => {
        console.log("save selection handler", docs);
        valueChange?.(docs)
        //setData(prev => ({ ...prev, documentId: docIds[0].id, document: docIds[0] }))
        setShowFileManager(false)
    }, [valueChange])

    //const btnIconDoc = useMemo((): dxButtonOptions => ({
    //    icon: "pdffile",
    //    stylingMode: "text",
    //    activeStateEnabled: false,
    //    focusStateEnabled: false,
    //    hoverStateEnabled: false
    //}), [])

    const btnClearDoc = useMemo((): dxButtonOptions => ({
        icon: "remove",
        stylingMode: "text",
        hint: "Alle documenten verwijderen van lijst?",
        disabled: false,
        onClick: () => valueChange?.(), //{ setData(prev => ({ ...prev, document: undefined, documentId: 0 })) },
        visible: docs.length > 1
    }), [docs, valueChange])

    const btnSelectDoc = useMemo((): dxButtonOptions => ({
        icon: "file",
        text: "Bestand" + (multiple ? "(en)" : "") + " selecteren",
        hint: "Selecteer bestaande documenten op de server",
        stylingMode: "text",
        disabled: false,
        //visible: !data.documentId,
        onClick: () => setShowFileManager(true)
    }), [multiple])

    const btnUploadDoc = useMemo((): dxButtonOptions => ({
        icon: "upload",
        text: "Bestand" + (multiple ? "(en)" : "") + " opladen",
        hint: "Een nieuw document uploaden.",
      //  elementAttr: { id: "uploadVr" },
        stylingMode: "text",
        disabled: false,
        //onClick
        //visible: !data.documentId,
        onClick: () => (refFileUpload.current?.instance as any)._selectButton.element().click()
    }), [multiple])

    const [isInDropZone, setIsInDropZone] = useState(false);
    const enterDropZone = useCallback(() => {
        setIsInDropZone(true);
    }, [])
    const leaveDropZone = useCallback(() => {
        setIsInDropZone(false);
    }, [])

    /*const allowedFileExtensions = useMemo(() => ([".pdf"]), [])*/
    const validateDoc = useCallback(() => !required || docs.length, [docs, required])

    const onDocUploadedHandler = useCallback((e: UploadedEvent) => {
        const json = JSON.parse(e.request.responseText) as TModel;
        console.log("File send completed", e, e.request.responseText, json);
        valueChange?.(multiple ? [ ...docs, json] : [json]);

    }, [valueChange, docs, multiple])

    const onDocErrorHandler = useCallback((e: UploadErrorEvent) => {
        e.message = "ERROR: " + e.request.responseText;
        console.log("docError", e);
    }, [])

    //const fileClickHandler = useCallback((e: ItemInfo) => {
    //    console.log("file click", e)
    //    window.open(apiUrl + "/" + e.itemData.id, "_BLANK", "noopener,noreferrer");
    //}, [apiUrl])

    //const tagTemplate = useCallback((data: TModel, tagElement: HTMLElement) => {
    //    console.log("tag", data, tagElement)
       
    //    tagElement.addEventListener('click', () => {
    //        window.open(apiUrl + "/" + data.id, "_BLANK", "noopener,noreferrer");
    //    })
    //    return tagElement;
    //    //console.log("test", e);
    //    //return <p>test</p>
    //}, [apiUrl])
    //const tagValueChangedHandler = useCallback((e: ValueChangedEvent) => {
    //    saveSelectionHandler(e.value)
    //}, [saveSelectionHandler])

    return <div className={"filedrop " + (isInDropZone ? "dropzone-active" : "")}>

        {/*check showFileManager zodat doc data pas geladen wordt na klikken*/}
        {showFileManager && <FileSelection<TModel>
            apiUrl={apiUrl}
            saveSelection={saveSelectionHandler}
            selectedDocs={docs}
            setShowFileManager={setShowFileManager}
            showFileManager={showFileManager}
            multiple={multiple}
        />}
        {/*<TextBox*/}
        {/*    readOnly*/}
        {/*    inputAttr={inputAttr}*/}
        {/*    placeholder={placeholder}*/}
        {/*    value={value?.[textFieldName || "fileName"]}>*/}
        {/*    <TextBoxButton name="pdffile" location="before" options={btnIconDoc} />*/}
        {/*    <TextBoxButton name="clearbtn" location="after" options={btnClearDoc} />*/}
        {/*    <TextBoxButton name="selectfile" location="after" options={btnSelectDoc} />*/}
        {/*    <TextBoxButton name="uploadfile" location="after" options={btnUploadDoc} />*/}
        {/*    <Validator>*/}
        {/*        <CustomRule message={requiredMessage} validationCallback={validateDoc} />*/}
        {/*    </Validator>*/}
        {/*</TextBox>*/}
        <TagBox
            //items={docs}
            label={label}
            value={docs}
            inputAttr={inputAttr}
            displayExpr={textFieldName || "fileName"} //werkt enkel met DS
            hideSelectedItems //lijst verbergen (dummy lijst met huidige waarden)
            openOnFieldClick={false}
            valueExpr="id" //werkt enkel met DS
            dataSource={dsDocs} //moet via DS anders werkt de delete button op items niet!
            placeholder={placeholder}
            onValueChange={saveSelectionHandler}
            //onItemClick={fileClickHandler}
            //tagTemplate={tagTemplate}
        >
            {/*<TagBoxButton name="pdffile" location="before" options={btnIconDoc} />*/}
            <TagBoxButton name="clearbtn" location="after" options={btnClearDoc} />
            <TagBoxButton name="selectfile" location="after" options={btnSelectDoc} />
            <TagBoxButton name="uploadfile" location="after" options={btnUploadDoc} />
            <Validator>
                <CustomRule message={requiredMessage} validationCallback={validateDoc} />
            </Validator>
        </TagBox>

        <FileUploader
            ref={refFileUpload}
            //id="vdDocUpload"
            className="docUploader"
            name={inputFormName || "file"} //"file" //belangrijk anders is File op server null!
            //selectButtonText="Visitatierapport opladen"
            selectButtonText=""
            //labelText="test.pdf"
            //accept="application/pdf"
            allowedFileExtensions={allowedExtensions}
            uploadMode="instantly"
            allowCanceling
            dropZone=".filedrop"            
            //showFileList
            uploadUrl={apiUrl}
            //dropZone=".container"                
            //onBeforeSend={beforeUploadDocHandler}
            uploadHeaders={headers}
            chunkSize={200000}
            //showFileList={false}
            multiple={multiple}
            minFileSize={1}
            maxFileSize={25 * 1024 * 1024}
            onDropZoneEnter={enterDropZone}
            onDropZoneLeave={leaveDropZone}
            onValueChanged={leaveDropZone} //reset on invalid drops
            invalidFileExtensionMessage="Het opgegeven bestandsformaat is ongeldig."
            invalidMaxFileSizeMessage="Het opgegeven bestand is te groot."
            uploadFailedMessage="Het uploaden is mislukt."
            //dialogTrigger="#uploadVr" // werkt niet omdat react element vervangen wordt (on textbox dataload)
            onUploaded={onDocUploadedHandler}
            onUploadError={onDocErrorHandler}
        />

    </div>
}
export default FileBox;